import { gql } from "@apollo/client"

const GET_MICROSERVICE_TOKENS = gql`
  {
    telerecovery: token(microservice_id: 1) {
      jwt
    }
    appointments: token(microservice_id: 2) {
      jwt
    }
    notifications: token(microservice_id: 4) {
      jwt
    }
    tasks: token(microservice_id: 5) {
      jwt
    }
    assessments: token(microservice_id: 6) {
      jwt
    }
    housing: token(microservice_id: 7) {
      jwt
    }
    documentSign: token(microservice_id: 8) {
      jwt
    }
    gpra: token(microservice_id: 9) {
      jwt
    }
    kiosk: token(microservice_id: 10) {
      jwt
    }
    employment: token(microservice_id: 11) {
      jwt
    }
    coordinationBoards: token(microservice_id: 14) {
      jwt
    }
    googlePlaces: getSecretValue(secret_name: "google_places_api_key") {
      data
    }
    mapBox: getSecretValue(secret_name: "mapbox_access_token") {
      data
    }
  }
`

export { GET_MICROSERVICE_TOKENS }
